import React from 'react'

function SvgGestionPaiement() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
    <path d="M2.49961 8.24988H17.4996M5.49961 11.7499H7.99961M4 4.75H15.9997C17.1042 4.75 17.9996 5.64473 17.9997 6.74927L17.9999 14.2508C17.9999 15.3554 17.1045 16.25 15.9999 16.25L4.00019 16.2499C2.89566 16.2498 2.00025 15.3545 2.00021 14.2499L2 6.75006C1.99997 5.64546 2.89541 4.75 4 4.75Z" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}

export default SvgGestionPaiement